import { useCallback, useMemo, useState } from 'react';
import { getLocalDevices, handleEvent, JazzRoom, LocalDevicesManager } from '@salutejs/jazz-sdk-web';
import { useDeviceSync } from './useDeviceSync';
import { handleError } from '../handleError';
import { useEnsureOnlyTwoParticipants } from './useEnsureOnlyTwoParticipants';

export const useConferenceRoom = ({ sdk, client, user }) => {
    const [ room, setRoom ] = useState<JazzRoom | null>(null);
    useDeviceSync();
    //useEnsureOnlyTwoParticipants({ room, user })

    const localDevices: LocalDevicesManager = useMemo(() => {
        if (!sdk) return null;
        return getLocalDevices(sdk);
    }, [sdk]);

    const handleConnectToConference = useCallback(async (conference) => {
        if (!localDevices || !client || !!room) return;

        try {
            await client.conferences.getDetails(conference);
        } catch (error) {
            handleError(error, 'Ошибка при подключении к конференции');
            return;
        }

        const newRoom = client.conferences.join(conference);

        try {
            const [audioStream, videoStream] = await Promise.all([
                localDevices.getSelectedAudioInputStream(),
                localDevices.getSelectedVideoInputStream(),
            ]);

            newRoom.setUserAudioInput(audioStream)
                .catch((err) => {
                    handleError(err, 'Ошибка при настройке микрофона');
                });
            newRoom.setUserVideoInput(videoStream)
                .catch((err) => {
                    handleError(err, 'Ошибка при настройке камеры');
                });

            const releaseMedia = () => {
                localDevices.releaseMediaStream(audioStream);
                localDevices.releaseMediaStream(videoStream);

                const displayStream = newRoom.displayStream.get();

                if (displayStream) {
                    localDevices.releaseMediaStream(displayStream);
                }
                setRoom(null);
            };

            handleEvent(newRoom.event$, 'destroy', releaseMedia, true);
        } catch (err) {
            handleError(err, 'Нет доступа к медиа-устройствам');
        }
        setRoom(newRoom);
    }, [localDevices, client, room]);

    return {
        room,
        connect: handleConnectToConference
    }
}
